import { useEffect } from 'react';
import { X } from 'lucide-react';

// Podgląd wygenerowanej grafiki na pełnym ekranie (lupka na miniaturach).

interface ImageLightboxProps {
  src: string;
  alt: string;
  onClose: () => void;
}

export function ImageLightbox({ src, alt, onClose }: ImageLightboxProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative max-w-[92vw] max-h-[92vh]">
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-10 p-1.5 rounded-full bg-surface-raised border border-border text-text-secondary hover:text-text-primary transition-colors shadow-lg"
          aria-label="Zamknij podgląd"
        >
          <X className="w-4 h-4" />
        </button>
        <img
          src={src}
          alt={alt}
          className="max-w-[92vw] max-h-[92vh] object-contain rounded-xl border border-border shadow-2xl"
        />
      </div>
    </div>
  );
}
